
(function ($) {

    // Scripts which runs after DOM load

    $(document).ready(function () {

        $('#toggle-menu').click( function (e) {
            e.stopPropagation();
            $(this).toggleClass('open');
            $('.menu-mob-box').toggleClass('open');
        });

        $(document).click(function (e) {
            if (
                !$(e.target).closest('.menu_list-mob').length &&
                !$(e.target).is('#toggle-menu')
            ) {
                $('.menu-mob-box').removeClass('open');
                $('#toggle-menu').removeClass('open');
            }
        });

        $('.menu_list-mob').click(function (e) {
            e.stopPropagation();
        });

        $('.menu_list-mob a').click(function () {
            $('.menu-mob-box').removeClass('open');
            $('#toggle-menu').removeClass('open');
        });

        $('.accordions__box-accordion').click(function () {
            const accordionContent = $(this).find('.accordions__box-accordion-content-text');
            if (accordionContent.length > 0) {
                $('.accordions__box-accordion').not(this)
                    .find(".accordions__box-accordion-content-text").slideUp();
                $('.accordions__box-accordion').not(this)
                    .find(".accordions__box-accordion-icon").removeClass('active');
                $(this).find(".accordions__box-accordion-content-text").slideToggle();
                $(this).find(".accordions__box-accordion-icon").toggleClass('active');
            }
        });

        $('.accordions-light__box-accordion').click(function () {
            const accordionContent = $(this).find('.accordions-light__box-accordion-content-text');
            if (accordionContent.length > 0) {
                $('.accordions-light__box-accordion').not(this)
                    .find(".accordions-light__box-accordion-content-text").slideUp();
                $('.accordions-light__box-accordion').not(this)
                    .find(".accordions-light__box-accordion-icon").removeClass('active');
                $(this).find(".accordions-light__box-accordion-content-text").slideToggle();
                $(this).find(".accordions-light__box-accordion-icon").toggleClass('active');
            }
        });

        $('.back-to-top-btn').click(() => {
            $('html, body').scrollTop(0);
        });

        const threeColumnsSlider = () => {
            let slider = $('.three-columns-slider__box');
            if (slider.length <= 0) return false;

            slider.slick({
                slidesToShow: 3,
                infinite: true,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3000,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            dots: true
                        }
                    }
                ]
            });
        }
        threeColumnsSlider();

        AOS.init({
            duration: 400,
            offset: 100
        });

    });

    // Scripts which runs after all elements load

    $(window).on('load', function () {


	});

    // Scripts which runs at window resize

    $(window).resize(function () {

        //jQuery code goes here

    });

}(jQuery));